
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

// Observable class extensions



// Observable operators








import { APIConfig } from './api.config';

/** 
 * See {@link WeatherComponent} which uses this service.
 */
@Injectable()
export class ApiObservablefactory {
    serviceurl = APIConfig.serviceURL;
    headers = APIConfig.apiHeader;
    options: RequestOptions;
    url: String = 'http://api.openweathermap.org/data/2.5/weather?q=';
    urlkey: String = '&APPID=fa6aceec31cb5c4a9a89a5bdf641882a';


    constructor(private http: Http) {
        this.options = new RequestOptions({ headers: this.headers });
    }

    getService(url = this.serviceurl): Observable<string> {
        return this.http
            .get(url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetWeather(city: string): Observable<string> {
        const apiurl = this.url + city + this.urlkey;
        return this.http
            .get(apiurl, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithDynamicQueryTerm(key: string, val: string, url = this.serviceurl): Observable<string> {
        return this.http
            .get(url + '/?' + key + '=' + val, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithFixedQueryString(param: any, url = this.serviceurl): Observable<string> {
        this.options = new RequestOptions({ headers: this.headers, search: 'query=' + param });
        return this.http
            .get(url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getServiceWithComplexObjectAsQueryString(param: any, url = this.serviceurl): Observable<string> {
        const params: URLSearchParams = new URLSearchParams();
        for (const key in param) {
            if (param.hasOwnProperty(key)) {
                const val = param[key];
                params.set(key, val);
            }
        }
        this.options = new RequestOptions({ headers: this.headers, search: params });
        return this.http
            .get(url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    createService(param: any, url = this.serviceurl): Observable<string> {
        const body = JSON.stringify(param);
        return this.http
            .post(url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateService(param: any, url = this.serviceurl): Observable<string> {
        const body = JSON.stringify(param);
        return this.http
            .put(url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }



    patchService(param: any, url = this.serviceurl): Observable<string> {
        const body = JSON.stringify(param);
        return this.http
            .patch(url, body, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteService(param: any, url = this.serviceurl): Observable<string> {
        const params: URLSearchParams = new URLSearchParams();
        for (const key in param) {
            if (param.hasOwnProperty(key)) {
                const val = param[key];
                params.set(key, val);
            }
        }
        this.options = new RequestOptions({ headers: this.headers, search: params });
        return this.http
            .delete(url, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteServiceWithId(key: string, val: string, url = this.serviceurl): Observable<string> {
        return this.http
            .delete(url + '/?' + key + '=' + val, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        const body = res.json();
        return body || {};
    }

    private handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}
